export default __webpack_public_path__ + "static/media/yuukke-white.a3cff30a.png";